/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const NewProductCardWrapper = styled.div`
  border-bottom: ${(props) => (props.$isMobile ? '0.5px solid #E6ECF2' : '')};
  padding-bottom: ${(props) => (props.$isMobile ? '8px' : '')};
`;
